import { JSX } from 'react'

import { IconProps } from '../../icon'

const Training: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M37.1757 12.3181C36.5025 11.6449 35.5995 11.2673 34.6308 11.2673H33.3666L33.4651 10.2494C33.5307 9.67471 33.3337 9.10005 32.9397 8.67317C32.5456 8.24628 32.0038 8 31.4127 8H16.8165C16.2419 8 15.6836 8.24628 15.2896 8.67317C14.8955 9.10005 14.7149 9.67471 14.7642 10.2494L14.8627 11.2837H13.5985C12.6298 11.2837 11.7267 11.6614 11.0536 12.3345C10.167 13.2211 9.80576 14.5346 10.1013 15.7496L10.9879 19.2632C11.3655 20.7737 12.4656 21.9559 13.9433 22.4484L17.1613 23.5156C17.1613 23.5156 17.3091 23.5485 17.3748 23.5485C18.327 24.7799 19.6077 25.7322 21.0854 26.3068L19.8211 32.6116H19.1808C17.6046 32.6116 16.3076 33.9087 16.3076 35.4849V38.7686C16.3076 39.4418 16.8658 40 17.539 40H30.6739C31.3471 40 31.9053 39.4418 31.9053 38.7686V35.4849C31.9053 33.9087 30.6082 32.6116 29.032 32.6116H28.3917L27.1275 26.3068C28.6051 25.7486 29.8858 24.7963 30.8381 23.5485C30.9038 23.5485 30.9858 23.5485 31.0515 23.5156L34.2696 22.4484C35.7473 21.9559 36.8473 20.7737 37.2249 19.2632L38.1116 15.7496C38.4235 14.5346 38.0459 13.2211 37.1593 12.3345L37.1757 12.3181ZM14.7314 20.117C14.0582 19.8871 13.5656 19.3453 13.385 18.6721L12.4984 15.1585C12.3999 14.7809 12.5148 14.354 12.794 14.0749C13.0074 13.8615 13.2865 13.7465 13.5985 13.7465H15.109L15.6508 19.2304C15.7001 19.6737 15.7986 20.1006 15.8971 20.511L14.6985 20.117H14.7314ZM29.4589 35.4849V37.5372H18.7868V35.4849C18.7868 35.255 18.9674 35.0744 19.1972 35.0744H29.0484C29.2783 35.0744 29.4589 35.255 29.4589 35.4849ZM25.9125 32.6116H22.3496L23.5153 26.7994C23.7288 26.7994 23.9258 26.8651 24.1393 26.8651C24.3527 26.8651 24.5497 26.8158 24.7632 26.7994L25.9289 32.6116H25.9125ZM24.1228 24.4023C21.0197 24.4023 18.442 22.0708 18.13 18.9841L17.2763 10.4464H30.9694L30.1157 18.9841C29.8037 22.0708 27.226 24.4023 24.1228 24.4023ZM34.8607 18.6557C34.6965 19.3453 34.1875 19.8871 33.5143 20.1006L32.3158 20.4946C32.4307 20.0677 32.5292 19.6573 32.562 19.214L33.1039 13.7301H34.6144C34.9263 13.7301 35.2054 13.845 35.4189 14.0585C35.698 14.3376 35.8129 14.7481 35.7144 15.1421L34.8278 18.6557H34.8607Z'
      fill='black'
    />
  </svg>
)

export default Training
